<template>
	<div id="Login">
		<video
			playsinline=""
			autoplay="autoplay"
			muted="muted"
			loop="loop"
			class="bg"
		>
			<source
				src="https://res.alphalawyer.cn/pluginInfo/live/企法中台登录页面视频.mp4"
				type="video/mp4"
			/>
		</video>
		<section>
			<div class="wrapper" id="weixin-qrcode"></div>
		</section>
		<div class="login-view-part">
			<div class="view-info">
				<div class="view-title">欢迎进入iCourt企业法律服务中台</div>
				<VuiButton
					class="btn weixin"
					type="warning"
					size="large"
					round
					long
					v-if="verifyCode"
					@click.native="weixinActiveLogin"
					>开通账号</VuiButton
				>
				<VuiButton
					class="btn weixin"
					type="warning"
					size="large"
					round
					long
					@click.native="weixinLogin"
					v-if="!verifyCode"
					>微信登录</VuiButton
				>
			</div>
			<div class="guide">
				<a
					href="https://res.alphalawyer.cn/pluginInfo/live/%E4%BC%81%E4%B8%9A%E6%B3%95%E5%BE%8B%E6%9C%8D%E5%8A%A1%E4%B8%AD%E5%8F%B0%E6%95%B0%E6%8D%AE%E5%BA%93%E6%8C%87%E5%BC%95.pdf"
					target="_blank"
					>初次使用？这里有一份详尽指引</a
				>
			</div>
		</div>
	</div>
</template>

<script>
	// import storage from '@/plugins/storage'
	export default {
		name: "Login",
		data() {
			return {
				verifyCode: this.$router.currentRoute.query.verifyCode,
			};
		},
		methods: {
			weixinLogin() {
				this.$store.dispatch("app/weixinLoginService");
			},
			weixinActiveLogin() {
				this.$store.dispatch("app/weixinActiveLogin");
			},
		},
		watch: {
			$route(to, from) {
				this.verifyCode = this.$router.currentRoute.query.verifyCode;
			},
		},
		mounted() {
			if (this.$router.currentRoute.query.verifyCode) {
				localStorage.setItem(
					"verifyCode",
					this.$router.currentRoute.query.verifyCode,
				);
			} else {
				localStorage.removeItem("verifyCode");
			}
		},
	};
</script>

<style lang="scss" scoped>
	#Login {
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		height: 100%;
		.bg {
			position: absolute;
			overflow: hidden;
		}
		.guide {
			position: absolute;
			bottom: 100px;
			a {
				color: white;
				font-size: 14px;
				text-decoration: underline;
			}
		}
		.login-view-part {
			z-index: 10;
			box-sizing: border-box;
			padding-left: 160px;
			position: fixed;
			width: 50%;
			height: 100%;
			background-color: rgba(0, 0, 0, 0.5);
			.view-info {
				height: auto;
				top: 30%;
				position: relative;
				-webkit-transform: translateY(-50%);
				transform: translateY(-50%);
				.view-title {
					margin-top: 64px;
					font-size: 30px;
					color: #fff;
				}
				.weixin {
					width: 98px;
					margin-top: 64px;
					padding: 10px 20px;
					font-size: 14px;
					border-radius: 4px;
					color: #fff;
					background-color: #ed6c00;
					border-color: #ed6c00;
				}
			}
		}

		main {
			width: 360px;
			padding: 100px 60px;
			border-radius: 8px;
			box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
			background-color: #ffffff;
			text-align: center;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);

			img {
				width: 128px;
				height: 128px;
			}

			.btn {
				padding: 12px;
				font-size: 14px;
				line-height: 20px;
				font-weight: normal;
			}

			.weixin {
				margin-top: 44px;
			}

			.passwd {
				margin-top: 24px;
				border-color: #f9f9f9;
				background-color: #f9f9f9;
				color: #868688;
			}
		}
	}

	.wrapper {
		position: absolute;
		left: 160px;
		top: calc(30% + 96px);
		width: 282px;
		height: 282px;
		box-sizing: content-box;
		border-radius: 4px;
		overflow: hidden;
		& /deep/ iframe {
      position: absolute;
      top: 0;
      left: 0;
			width: 282px;
			box-sizing: content-box;
			border-radius: 4px;
			background-color: #ffffff;
			border-radius: 4px;
			z-index: 1000;
			transform: translateY(-47px);
		}
	}
</style>
